import Layout from '@/libs/components/Layout'
import styles from './index.scss'
import { useEffect, useState } from 'react'
import { productProductList } from '@/services'
import { getUrlAllParams } from '@/libs/functions/getValue'
import { onGotoGoodsDetail } from '@/libs/functions/tools'
import { Image } from 'antd-mobile'

export default function DiscountCouponGoodsList() {
  const { couponMemberId = '', couponTemplateId = '' } =
    getUrlAllParams() as any
  const [listData, setListData] = useState<any[]>([])

  useEffect(() => {
    getListData()
  }, [])

  const getListData = async () => {
    if (!couponMemberId && !couponTemplateId) return
    const res: any = await productProductList({
      couponMemberId,
      couponTemplateId,
    })
    if (res) {
      setListData(res || [])
    }
  }

  return (
    <Layout title={'优惠券商品列表'} backArrow={true}>
      <div className={styles.container}>
        {listData.map((item: any) => (
          <div className={styles.item}>
            <div className={styles.inner}>
              {/* <img src={item.listViewUrl} className={styles.img} /> */}
              <Image
                lazy
                fit="cover"
                className={styles.img}
                src={item.listViewUrl}
              />
              <div className={styles.right}>
                <div className={styles.name}>{item.proName}</div>
                <div className={styles.desc}>{item.proDesc}</div>
                <div className={styles.bottom}>
                  <div className={styles.price}>
                    ￥{item.exchangePrice}
                    {item.exchangePriceSuffix === 1 ? '起' : ''}
                  </div>
                  <div
                    className={styles.btn}
                    onClick={() =>
                      onGotoGoodsDetail(
                        item.virtuallyType || item.categoryType,
                        item.proCode,
                      )
                    }
                  >
                    立即购买
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  )
}
